import Close from "assets/icons/close-btn.svg";
import { ReactComponent as ImgIcon } from "assets/icons/img-icon.svg";
import { useFormik } from "formik";
import {
  fetchStates,
  getAllSpecies,
} from "modules/dashboard/_redux/stand/standActions";
import { addTrophy, getReservationDetail } from "modules/dashboard/_redux/reservations/reservationActions";
import { LightgalleryProvider, LightgalleryItem } from "react-lightgallery";
import moment from "moment";
import React, { useEffect } from "react";
import { FloatingLabel, Form } from "react-bootstrap";
import Spinner from "components/UI/Spinner.js";
import { shallowEqual, useSelector } from "react-redux";
import * as Yup from "yup";
import "./style.scss";
import toastHandler from "components/UI/toastHandler/toastHandler";


export default function Trophy({ reservationDetail, dispatch }) {
  const fileInputRef = React.createRef();

  useEffect(() => {
    dispatch(getAllSpecies());
    dispatch(fetchStates());
  }, []);

  const { species, isLoading, user } = useSelector(
    (state) => ({
      states: state.stand.states,
      species: state.stand.species,
      isLoading: state.reservation.actionsLoading,
      user: state.auth.user,
    }),
    shallowEqual
  );

  const fileUploadHandler = (e) => {
    const { files } = e.target;
    if (!files) return;
    if (Object.entries(files).length === 0) return;
    var reader = new FileReader();
    const file = files[0];
    reader.readAsDataURL(file);
    reader.onload = (_event) => {
      formik.setFieldValue("image", {
        previewUrl: reader.result,
        file: file,
        fileName: file.name,
      });
    };
  };

  const onTropySubmit = (values) => {
    const { image, name, specie, harvest_date, comment } = values;
    const data = new FormData();
    data.append("image", image.file);
    data.append("name", name);
    data.append("specie", specie);
    data.append("harvest_date", harvest_date);
    data.append("comment", comment);
    dispatch(addTrophy(data, reservationDetail?.id, image.file, onSuccess));
  };

  const validationSchema = Yup.object().shape({
    image: Yup.object().nullable().required("Please select picture"),
    name: Yup.string(),
    specie: Yup.string().required("Please select specie"),
    harvest_date: Yup.string().required("Please select harvest date"),
    comment: Yup.string(),
  });

  const formik = useFormik({
    initialValues: {
      image: null,
      name: "",
      specie: "",
      harvest_date: moment().format("MMM DD YYYY"),
      comment: "",
    },
    validationSchema,
    onSubmit: onTropySubmit,
  });

  const onSuccess = (message) => {
    toastHandler(message, "success");
    dispatch(getReservationDetail(reservationDetail?.id));
  }

  useEffect(() => {
    if (!user) return;
    formik.setFieldValue("name", `${user.first_name} ${user.last_name}`);
  }, [user]);

  const canSubmitTrophy = () => {
    if (reservationDetail?.trophy === null &&
      reservationDetail?.current_user_type == "main_hunter" &&
      user && reservationDetail?.stand_detail?.user?.id != user?.id) {
      return true
    } else return false
  }

  const getTextClass = (status) => {
    if (status === "pending") {
      return "text-warning"
    } if (status === "approved") {
      return "text-primary "
    } else return "text-rejected"

  }

  const getDotClass = (status) => {
    if (status === "pending") {
      return "dot-warning"
    } if (status === "approved") {
      return "dot-primary "
    } else return "dot-secondary"
  }

  return (
    <div className="col-xxl-6">
      {canSubmitTrophy() ? (
        <div className="trophy-wrapper">
          <div className="row">
            <div className="col-12">
              {reservationDetail?.trophy ?
                <div className="title-area">
                  <h3>Trophy</h3>
                  <p>Harvested trophy by hunter</p>
                </div> : reservationDetail?.current_user_type == "main_hunter" ?
                  <div className="title-area">
                    <h3>Submit Trophy</h3>
                    <p>Participate in Trophy room to get discount vouchers</p>
                  </div> : null}
            </div>
          </div>
          <Form className="trophy-form" onSubmit={formik.handleSubmit}>
            <div className="row">
              <div className="col-md-12">
                <div className="field-group">
                  {formik.values.image !== null ? (
                    <div className="res-image-upload py-0">
                      <div className="uploaded-img-inner">
                        <img src={formik.values.image.previewUrl} alt="" />
                        <div
                          className="close-btn cursor-pointer"
                          onClick={() => {
                            formik.setFieldValue("image", null);
                          }}
                        >
                          <img src={Close} alt="" />
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="res-image-upload text-center">
                      <input
                        type="file"
                        hidden
                        ref={fileInputRef}
                        onChange={fileUploadHandler}
                        accept="image/png, image/jpeg"
                      />
                      <ImgIcon
                        className="upload-icon cursor-pointer mb-2"
                        onClick={() => {
                          fileInputRef.current.click();
                        }}
                      />
                      <p className="mb-0 fw-bold fs-6">Drag your photo here</p>
                      <a
                        className="mt-1 cursor-pointer"
                        onClick={() => {
                          fileInputRef.current.click();
                        }}
                      >
                        Upload Image
                      </a>
                    </div>
                  )}
                  {formik?.touched?.image && formik?.errors?.image && (
                    <Form.Control.Feedback type="d-block invalid">
                      {formik.errors.image}
                    </Form.Control.Feedback>
                  )}
                </div>
                <div className="trophy-fields-wrapper w-100 mw-100">
                  <div className=" field-group">
                    <FloatingLabel controlId="floatingInput" label="Name">
                      <Form.Control
                        type="text"
                        name="name"
                        placeholder="Name"
                        value={formik.values.name}
                        onChange={formik.handleChange}
                      />
                    </FloatingLabel>
                  </div>
                  <div className="field-group">
                    <FloatingLabel
                      controlId="floatingSelectGrid"
                      label="Specie"
                      className="speciesSelect"
                    >
                      <Form.Select
                        aria-label="FloatingSelect"
                        name="specie"
                        onChange={(event) => {
                          formik?.setFieldValue("specie", event.target.value);
                        }}
                      >
                        <option value="">Select specie </option>
                        {species?.length > 0 &&
                          species.map((specie, index) => (
                            <option value={specie.id} key={index}>
                              {specie.specie_name}
                            </option>
                          ))}
                      </Form.Select>
                    </FloatingLabel>
                    {formik?.touched?.specie && formik?.errors?.specie && (
                      <Form.Control.Feedback type="d-block invalid">
                        {formik.errors.specie}
                      </Form.Control.Feedback>
                    )}
                  </div>
                </div>
                <div className="field-group">
                  <textarea
                    className="res-feedback"
                    placeholder="Type your comment..."
                    value={formik.values.comment}
                    onChange={formik.handleChange}
                    name="comment"
                  />
                </div>
              </div>
              <div className="col-12">
                <div className="text-end">
                  <button type="submit" className="btn btn-primary text-white d-block mr-auto">
                    {isLoading ? (
                      <Spinner />
                    ) : (
                      "SUBMIT"
                    )}
                  </button>
                </div>
              </div>
            </div>
          </Form>
        </div>
      ) : (
        reservationDetail?.trophy ?
          <div className="trophy-wrapper">
            <div className="row">
              <div className="col-12">
                {reservationDetail?.trophy ?
                  <div className="title-area">
                    <h3>Trophy</h3>
                    <p>Harvested trophy by hunter</p>
                  </div> : reservationDetail?.current_user_type == "main_hunter" ?
                    <div className="title-area">
                      <h3>Submit Trophy</h3>
                      <p>Participate in Trophy room to get discount vouchers</p>
                    </div> : null}
              </div>
            </div>
            <div className="res-image-upload py-0 after-submit h-auto">
              <div className="trophies-dashboard w-100">
                <div className="trophy-box">
                  <div className="p-4 d-flex align-items-center justify-content-between">
                    <LightgalleryProvider >
                      <LightgalleryItem group="any" src={reservationDetail?.trophy?.image ||
                        formik?.values?.image?.previewUrl}>
                        <div className="trophies-img cursor-pointer">
                          <img src={
                            reservationDetail?.trophy?.image ||
                            formik?.values?.image?.previewUrl
                          } alt="" />
                          <svg xmlns="http://www.w3.org/2000/svg" width="92.024" height="54.685" viewBox="0 0 92.024 54.685" className="singh">
                            <g id="LOGO" transform="translate(19.477 11.574)">
                              <path
                                id="Path_337"
                                data-name="Path 337"
                                d="M2246.5-344.783,2245.4-347l-1.493-1.985-1.542-1.732-1.8-1.467-1.389-.8v-.038l-.558-2.213-.416-1.808-.177-1.833-.178-3.1-.3-2.364-.112-.2-.229-.05-.191.1-.075.228-.039,1.517-.19,1.5-.316,1.884-.114,1.9.09,1.555.291,1.517v.013h-.053l-.162.126-.064.19.064.19.467.733.012.051.127,1.416-.051,1.429.064,3.578.088,1.353.2,1.353.227,1.378.075,1.391-.187.683-.405.569-.581.4-2.543.986-2.668.607h-.847l-.81-.278-.669-.531-.457-.721-.719-2.706-.431-2.756-.165-3.2.191-3.212-.1-1.96-.4-1.922-.686-1.833-.606-1.808-.366-1.871-.227-.847-.406-1.366-.039-.164-.138-.1-.163-.013-.14.1-.064.152.405,3,.594,2.971.317,1.783.076,1.808-.179,1.808-.24.253-.353.076-.317-.126-.821-.417-.533-.278-.138-.076-.153.013-.087.063-.039.114.039.1.4.518.454.506.634,1.011.416,1.694.2,1.732-.039,1.732-.052,1.783.153,1.783.43,2.238.1,1.239.015-.013v.114l-.015-.1-.225.48-.469.291-2.9.746-2.742,1.189-1.341.645-1.264.759-.481.114-.442-.2-.242-.442-.011.379-.176-1.719-1.252-4.324-1.518-4.236-.6-1.618-.708-2.971-.505-3.009-.19-1.113-.339-2.1-.066-.076-.1-.013-.075.05-.024.089-.353,2.15-.229,2.263.012,2.289.265,2.263.963,5.4,1.2,5.361.163,2.643-.1,2.655-.52,3.047-.845,2.984-1.153,2.858-1.289,2.2-1.68,1.909-2.011,1.555-2.262,1.163h-4.794l-2.7.708,5.675-.708-2.262-1.163-2.011-1.555-1.68-1.909-1.277-2.2-1.165-2.858-.846-2.984-.519-3.047-.1-2.655.165-2.643,1.2-5.361.962-5.4.266-2.263.011-2.289-.229-2.263-.339-2.15-.038-.089-.075-.05-.1.013-.052.076-.352,2.1-.19,1.113-.505,3.009-.708,2.971-.6,1.618-1.517,4.236-1.251,4.324-.178,1.719-.011-.379-.24.442-.442.2-.483-.114-1.264-.759-1.341-.645-2.742-1.189-2.9-.746-.468-.291-.225-.48-.015.1v-.114l.015.013.1-1.239.43-2.238.151-1.783-.05-1.783-.039-1.732.2-1.732.417-1.694.633-1.011.454-.506.4-.518.038-.1-.024-.114-.1-.063-.152-.013-.14.076-.518.278-.834.417-.318.126-.353-.076-.24-.253-.176-1.808.074-1.808.317-1.783.6-2.971.4-3-.064-.152-.139-.1-.164.013-.139.1-.039.164-.4,1.366-.226.847-.367,1.871-.606,1.808-.686,1.833-.4,1.922-.1,1.96.19,3.212-.165,3.2-.431,2.756-.719,2.706-.456.721-.67.531-.809.278h-.847l-2.669-.607-2.539-.986-.582-.4-.406-.569-.187-.683.075-1.391.226-1.378.2-1.353.088-1.353.062-3.578-.049-1.429.126-1.416.012-.051.467-.733.064-.19-.064-.19-.164-.126h-.052v-.013l.291-1.517.09-1.555-.115-1.9-.315-1.884-.19-1.5-.038-1.517-.075-.228-.19-.1-.227.05-.114.2-.3,2.364-.177,3.1-.18,1.833-.415,1.808-.557,2.213v.038l-1.39.8-1.8,1.467-1.542,1.732L2156.388-347l-1.1,2.213-.406,1.568.1,1.618.583,1.5,1.025,1.265,1.35.885,4.176,1.492,4.247,1.188,4.338.885,3.577.923,3.439,1.353,3.236,1.77,1.619,1.2,1.455,1.4,1.251,1.58,1.164,1.682.936,1.808.7,1.922,1.125,2.491,1.492,2.276,1.834,2.023,2.124,1.707,2.365,1.365,2.552.973h2.659l2.553-.973,2.365-1.365,2.124-1.707,1.834-2.023,1.491-2.276,1.126-2.491.7-1.922.936-1.808,1.163-1.682,1.266-1.58,1.439-1.4,1.62-1.2,3.249-1.77,3.427-1.353,3.58-.923,4.336-.885,4.247-1.188,4.173-1.492,1.351-.885,1.024-1.265.582-1.5.1-1.618Zm-84.513-2.251-.38,2.756-.543,2.719-.279.556-.506.367-.618.1-.886-.329-.682-.682-.329-.885.064-.948,1.163-2,1.389-1.846,1.86-2.2Zm81.706,5.488-.671.682-.9.329-.62-.1L2241-341l-.278-.556-.545-2.719-.379-2.756-.251-2.39,1.857,2.2,1.393,1.846,1.16,2,.064.948Z"
                                transform="translate(-2174.359 353.009)"
                                fill="#EA9B45"
                              ></path>
                              <path id="Path_338" data-name="Path 338" d="M2171.958-343.276l-.006.059v-.066Z" transform="translate(-2159.505 358.814)" fill="#EA9B45"></path>
                              <path id="Path_339" data-name="Path 339" d="M2217.009-343.283v.066l-.007-.059Z" transform="translate(-2171.706 358.814)" fill="#EA9B45"></path>
                            </g>
                          </svg>
                        </div>
                      </LightgalleryItem>
                    </LightgalleryProvider>

                    <div className="d-flex flex-column justify-content-end">
                      <button className="btn p-0" style={{ cursor: "default" }}>
                        {reservationDetail?.trophy?.harvest_date}
                      </button>
                      <div className={`text-warning d-flex align-items-center justify-content-end fs-14
                       ${getTextClass(reservationDetail?.trophy?.status)}`}
                      >
                        <span className={getDotClass(reservationDetail?.trophy?.status)}>
                        </span>
                        {reservationDetail?.trophy?.status}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> : null
      )
      }
    </div >
  );
}
